export const RESTORE_STATUS = {
    CURRENT: 'CURRENT',
    RESTORE: 'RESTORE'
};



// WEBPACK FOOTER //
// ./src/constants/RestoreStatus.js